const setViewHeight = () => {
  document.body.style.setProperty('--vh', `${window.innerHeight / 100}px`)
}

export default setViewHeight
